import { render } from "./metric-identifier.vue?vue&type=template&id=8a62b4ee"
import script from "./metric-identifier.vue?vue&type=script&lang=js"
export * from "./metric-identifier.vue?vue&type=script&lang=js"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__